module.exports = __webpack_public_path__ + "img/close.68c26c5c.svg";